import React from 'react';
import styles from './AdvtFullSize.module.css';
import cn from 'classnames';
import { iconsSources } from '../../helpers/icons';
import { useGetParams } from '../../hooks/useGetParams';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const AdvtFullSize = React.memo(({ className, advtInfo }) => {
  const {
    paddingQR,
    sizeQR,
    titleFontSize,
    phoneNumberFontSize,
    clrBgAdvt,
    clrTextAdvt,
  } = useGetParams();

  let phoneNumberFormat = formatPhoneNumber(advtInfo?.number, '-');

  return (
    <div className={cn(className)}>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          {(advtInfo.label || advtInfo.number) && (
            <div className={styles.info} style={{ backgroundColor: clrBgAdvt }}>
              <div
                className={styles.title}
                style={{ fontSize: `${titleFontSize}rem`, color: clrTextAdvt }}>
                {advtInfo.label}
              </div>
              <div
                className={styles.number}
                style={{ fontSize: `${phoneNumberFontSize}rem` }}>
                {phoneNumberFormat}
              </div>
            </div>
          )}

          <div className={styles.socials}>
            {advtInfo.socials &&
              advtInfo.socials.map((item) => (
                <div key={item} className={styles.icon}>
                  <img src={iconsSources[item]} alt="social" />
                </div>
              ))}
          </div>
        </div>
        {advtInfo.qrCode && (
          <div
            className={styles.right}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}>
            <img src={advtInfo.qrCode} alt="" />
          </div>
        )}
      </div>
    </div>
  );
});

export default AdvtFullSize;
